import React from "react";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import LandingPage from "./LandingPage";
import LoginPage from "./login/LoginPage";
import HomePage from "./HomePage";
import PrivateRoute from "../components/common/PrivateRoute";
import ScrollToTop from "../components/common/ScrollToTop";
import VerifyPage from "./login/VerifyPage";
import SavetiPage from "./SavetiPage";
import ONamaPage from "./ONamaPage";
import KontaktPage from "./KontaktPage";
import ForgetPasswordPage from "./login/ForgetPasswordPage";
import ChangePasswordPage from "./login/ChangePasswordPage";

function App() {

    return (
        <>
            <BrowserRouter>
                <Routes>
                    <Route index element={<LandingPage />} />
                    <Route path="/" element={<LandingPage />}></Route>

                    <Route path="/login" element={<LoginPage />}></Route>
                    <Route path="/verify" element={<VerifyPage />}></Route>
                    <Route path="/saveti" element={<SavetiPage />}></Route>
                    <Route path="/o_nama" element={<ONamaPage />}></Route>
                    <Route path="/kontakt" element={<KontaktPage />}></Route>
                    <Route path="/zaboravljena_lozinka" element={<ForgetPasswordPage />}></Route>
                    <Route path="/promena_lozinke" element={<ChangePasswordPage />}></Route>

                    <Route path="/home" element={<PrivateRoute element={<HomePage />} />} />
                </Routes>
                <ScrollToTop />
            </BrowserRouter>
        </>
    )
}

export default App;